import styled from "styled-components";
import { ThemeButton } from "@sc/custom.styled";

export const FormContainer = styled.form`
  padding: 28px;
  background: linear-gradient(180deg, #fffdf9 0%, #ffffff 100%);
  border-radius: 10px;
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  box-sizing: border-box;
`;

export const FormTitle = styled.h2`
  margin-top: 0;
  margin-bottom: 6px;
  color: rgba(0, 0, 0, 0.78);
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
  font-size: 13px;
  letter-spacing: 0.01em;
`;

const fieldStyles = `
  width: 100%;
  padding: 12px 14px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  box-sizing: border-box;
  background: #fff;
  color: rgba(0, 0, 0, 0.78);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: rgba(0, 0, 0, 0.32);
  }

  &:focus {
    border-color: #ff8a23;
    box-shadow: 0 0 0 3px rgba(255, 138, 35, 0.14);
    outline: none;
  }
`;

export const Input = styled.input`
  ${fieldStyles}
`;

export const TextArea = styled.textarea`
  ${fieldStyles}
  min-height: 120px;
  font-family: inherit;
  resize: vertical;
`;

export const FileLabel = styled.label`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background-color: rgba(255, 138, 35, 0.1);
  border: 1px solid rgba(255, 138, 35, 0.3);
  border-radius: 999px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #ff8a23;
  margin-bottom: 12px;
  transition: all 0.2s ease;

  input {
    display: none;
  }

  &:hover {
    background-color: rgba(255, 138, 35, 0.16);
    border-color: rgba(255, 138, 35, 0.48);
  }
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.64);
  font-weight: 500;

  input {
    margin-right: 10px;
    accent-color: #ff8a23;
  }
`;

export const SubmitButton = styled(ThemeButton)`
  width: 100%;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 600;
  margin-top: 10px;

  &:disabled {
    background-color: #d9d9d9;
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }
`;

export const ErrorText = styled.div`
  color: #cf1322;
  background: #fff1f0;
  border: 1px solid #ffa39e;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 12px;
  margin: 12px 0 0;
`;

export const SuccessMessage = styled.div`
  color: #389e0d;
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 10px;
  padding: 10px 15px;
  margin-top: 15px;
  text-align: center;
`;
